var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-form-label"},[_c('span',{staticClass:"dp-form-label__text"},[_vm._t("default")],2),(_vm.helpText)?_c('dp-icon',{staticClass:"dp-form-label__help",attrs:{"name":"question","tooltip":_vm.helpText}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }